import { config } from './config';
import axios from 'axios';

export const vaultServices = {
    fetchVaultDetail,
    fetchTempAccessCode, 
    fetchBLEDeviceInfo,
    sendAuditInfo ,
    fetchOpenCloseCodes
};



/*==========================================================================*/
async function fetchVaultDetail(assetTag, userId, token, orgId) {
            
    try {
        const response = await axios({
                                        method: 'post',
                                        headers: {  'mode':'cors',
                                                    'Access-Control-Allow-Origin': "*",
                                                    'Authorization': 'Bearer ' + token},
                                        url: config.apiUrl + '/VaultDomain/fetchVaultDetails',
                                        data: {                                                                                        
                                            userId: userId,
                                            assetTag: assetTag,
                                            orgId: orgId
                                        }
                                    });
        return response
    } catch (error) {
        return error.response
    }
}
/*==========================================================================*/
async function fetchTempAccessCode(userId, assetTag, token, orgId, tempCodeJustification, tempCodeFetchMethod) {
    // const tempCodeJustification = "mobile app scan";
   
    //console.log("in", userId, assetTag, token)
   
    try {
        const response = await axios({
                                        method: 'post',
                                        headers: {  'mode':'cors',
                                                    'Access-Control-Allow-Origin': "*",
                                                    'Authorization': 'Bearer ' + token},
                                        url: config.apiUrl + '/VaultDomain/fetchTempAccessCode',
                                        data: {
                                                assetTag: assetTag,
                                                tempCodeJustification: tempCodeJustification,
                                                userId: userId,
                                                orgId: orgId,
                                                tempCodeFetchMethod: tempCodeFetchMethod
                                        }
                                    });
        //console.log(response)
        return response               
    } catch (error) {
        //console.log(error.response.data);       
        return error.response

    }
}
/*==========================================================================*/
async function fetchBLEDeviceInfo(deviceId) {
   
    let x = JSON.parse(sessionStorage.getItem("user"));
    let bleDevices = [{"DeviceId":deviceId,"OrgId":x.orgId,"UserId":x.userId}];
    
    // var test = 
    //     [{
    //         "DeviceId": "A29VLP",
    //         "OrgId": "Demo",
    //         "UserId": 1
    //     },
    //     {
    //         "DeviceId": "A25PA1",
    //         "OrgId": "Demo",
    //         "UserId": 1
    //     }];
    // var test = 
    // [{"DeviceId":"A29VLP","OrgId":"Demo","UserId":1}];

    //  console.log("...",unescape(bleDevices))
    // console.log("??",bleDevices)
    // var bleDevicesOut = unescape(bleDevices);

    //console.log("after",bleDevices);

    //   return true;
    try {
       
        const response = await axios({
                                        method: 'post',
                                        headers: {  'mode':'cors',
                                                    'Access-Control-Allow-Origin': "*",
                                                    'Authorization': 'Bearer ' + x.token},
                                        url: config.apiUrl + '/VaultDomain/fetchBLEDeviceInfo',
                                        data: {
                                                // bleDevices: JSON.parse(unescape(unescape(unescape(bleDevicesOut))))
                                                bleDevices: bleDevices
                                                
                                        }
                                    });
        // 
        
        //console.log("the response:",JSON.stringify(response));
        return response             
    } catch (error) {
        //console.log(error.response.data);       
        return error.response

    }
}
/*==========================================================================*/
async function sendAuditInfo(events) {
    
    // console.log("events", JSON.stringify(events));
   // return true;
   let x = JSON.parse(sessionStorage.getItem("user"));
   
    try {
       
        const response = await axios({
                                        method: 'post',
                                        headers: {  'mode':'cors',
                                                    'Access-Control-Allow-Origin': "*",
                                                    'Authorization': 'Bearer ' + x.token},
                                        url: config.apiUrl + '/VaultDomain/sendAuditInfo',
                                        data: {                                                
                                            bleAuditEvents: events
                                        }
                                    });
        
        
        console.log("the response:",JSON.stringify(response));
        return response             
    } catch (error) {
        //console.log(error.response.data);       
        return error.response

    }
  
}
/*==========================================================================*/
async function fetchOpenCloseCodes(userId, assetTag, token, orgId, tempCodeJustification, openCloseCodesDate) {
    
    // let x = JSON.parse(sessionStorage.getItem("user"));
    
    if(openCloseCodesDate === null){
        openCloseCodesDate = new Date();
    }
    
    try {
        const response = await axios({
                                        method: 'post',
                                        headers: {  'mode':'cors',
                                                    'Access-Control-Allow-Origin': "*",
                                                    'Authorization': 'Bearer ' + token},
                                        url: config.apiUrl + '/VaultDomain/fetchOpenCloseCodes',
                                        data: {
                                                assetTag: assetTag,
                                                userId: userId,
                                                tempCodeJustification: tempCodeJustification,                                                
                                                orgId: orgId,
                                                openCloseCodesDate: openCloseCodesDate
                                        }
                                    });
      console.log("theResponse: ", JSON.stringify(response))
        return response               
    } catch (error) {
      //  console.log(JSON.stringify(error.response.data))
        if(error){
            return error.response;
        }
        

    }
}
/*==========================================================================*/


// WEBPACK FOOTER //
// ./src/libs/VaultServices.js